import { callbackRoute, PrivateRoute } from '@airship-platform/airship-auth';
import {
  AuthenticatedUserProvider,
  BaseTemplate,
  composeProviders,
  withPageProps,
} from '@airship-platform/airship-patterns';
import {
  AuthFrame,
  Loader,
  NotFoundPage as BaseNotFoundPage,
} from '@airship-platform/jam-web/components';
import { Navigate, RouteObject } from 'react-router';
import ForgotPasswordPage from './features/ForgotPasswordPage';
import ProfilePage from './features/ProfilePage';
import ResetPasswordPage from './features/ResetPasswordPage';
import SignInPage from './features/SignInPage';
import SignOutPage from './features/SignOutPage';
import VerifyEmailPage from './features/VerifyEmailPage';

const AuthenticationComposedProviders = composeProviders(
  AuthenticatedUserProvider
);

const SignInPageImpl = withPageProps(SignInPage, {
  title: 'Sign In',
});
const SignOutPageImpl = withPageProps(SignOutPage, {
  title: 'Sign Out',
});
const ForgotPasswordPageImpl = withPageProps(ForgotPasswordPage, {
  title: 'Forgot Password',
});
const ResetPasswordPageImpl = withPageProps(ResetPasswordPage, {
  title: 'Reset Password',
});
const VerifyEmailPageImpl = withPageProps(VerifyEmailPage, {
  title: 'Verify Email',
});
const ProfilePageImpl = withPageProps(ProfilePage, {
  title: 'User Profile',
});

export const ROUTE_PATHS = {
  HOME: '/',
  SIGNIN: '/signin',
  SIGNOUT: '/signout',
  PROFILE: '/profile',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-forgot-password',
  VERIFY_EMAIL: '/verify-email',
};

const routes: RouteObject[] = [
  callbackRoute(),
  {
    path: '*',
    Component: withPageProps(BaseNotFoundPage, { title: 'Page not found' }),
  },
  {
    path: ROUTE_PATHS.HOME,
    element: <Navigate to={ROUTE_PATHS.PROFILE} replace={true} />,
  },
  {
    path: ROUTE_PATHS.SIGNIN,
    element: <AuthFrame />,
    children: [
      {
        index: true,
        element: <SignInPageImpl />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.SIGNOUT,
    element: <SignOutPageImpl />,
  },
  {
    path: ROUTE_PATHS.FORGOT_PASSWORD,
    element: <AuthFrame />,
    children: [
      {
        index: true,
        element: <ForgotPasswordPageImpl />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.RESET_PASSWORD,
    element: <AuthFrame />,
    children: [
      {
        index: true,
        element: <ResetPasswordPageImpl />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.VERIFY_EMAIL,
    element: <AuthFrame />,
    children: [
      {
        index: true,
        element: <VerifyEmailPageImpl />,
      },
    ],
  },
  {
    path: ROUTE_PATHS.PROFILE,
    element: (
      <PrivateRoute loadingComponent={<Loader isLoading />}>
        <AuthenticationComposedProviders>
          <BaseTemplate />
        </AuthenticationComposedProviders>
      </PrivateRoute>
    ),
    children: [
      {
        index: true,
        element: <ProfilePageImpl />,
      },
    ],
  },
];

export default routes;
